var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xm-language-tab"},_vm._l((_vm.currencyList),function(item){return _c('div',{key:item.value,staticClass:"currency-type",class:{ 'chose-type': _vm.pageCurrency == item.value },on:{"click":function($event){return _vm.changePageCurrency(item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }